export default class ArchiveFiltersManager {
  constructor() {
    this.params = new URLSearchParams(window.location.search);
    this.queryContainer = document.querySelector('.wp-block-query');
  }

  setParam(key, value) {
    if (!value || value === 'all' || value.length === 0) {
      this.params.delete(key);
    } else {
      this.params.set(key, value);
    }

    this.resetPage();
    this.fetchResults();
  }

  getParam(key) {
    return this.params.get(key);
  }

  resetPage() {
    const url = new URL(window.location);

    const parts = url.pathname.split('/').filter(Boolean);
    const pageIndex = parts.indexOf('page');
    if (pageIndex !== -1) {
      parts.splice(pageIndex, 2);
    }

    url.pathname = '/' + parts.join('/') + '/';
    url.search = this.params.toString();

    window.history.pushState({}, '', url.toString());
  }

  async fetchResults() {
    if (!this.queryContainer) return;

    try {
      this.queryContainer.innerHTML = '<p>Loading...</p>';

      const url = `${window.foolArchiveFilters.ajaxUrl}?action=get_filtered_posts&${this.params.toString()}`;
      const response = await fetch(url, {
        headers: { 'X-WP-Nonce': window.foolArchiveFilters.nonce },
      });

      const data = await response.json();
      if (data.success) {
        this.queryContainer.innerHTML = data.data.html;
      }
    } catch (err) {
      console.error('Filter AJAX failed', err);
    }
  }
}
